module.exports = __webpack_public_path__ + "media/public/images/icon-trigger-dropdown-3e09ebe2df16c2798a3c38912be3f4d3.svg";